import { decode } from "cborg";
import { checkLibraryEmpty, dbPromise } from "../db";
/** Show an upload dialog and add the uploaded CBOR to the library */
export async function importLibrary() {
    let cbor = await uploadFile();
    let decoded = decode(new Uint8Array(cbor));
    let db = await dbPromise;
    let transaction = db.transaction("library", "readwrite");
    let store = transaction.objectStore("library");
    await Promise.all(decoded.map((item) => store.put(item)));
    await checkLibraryEmpty();
}
/** Show a dialog for uploading a file and return it as an ArrayBuffer */
function uploadFile() {
    return new Promise((resolve, reject) => {
        let input = document.createElement("input");
        input.type = "file";
        input.accept = "application/cbor";
        input.oninput = () => {
            if (!input.files) {
                return;
            }
            let reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(input.files[0]);
        };
        input.onerror = reject;
        input.click();
    });
}
